import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoubleCheckmarkIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.5014 3.85991L11.0458 4.45567L7.70557 8.82361L7.29106 8.4091L6.63552 7.75356L9.85422 3.5445L10.3098 2.94873L11.5014 3.85991ZM4.10908 11.5911L4.90218 12.3842C4.22548 12.8947 3.24459 12.8554 2.61207 12.223L0.669059 10.2804L0.138672 9.75014L1.19922 8.68937L1.72961 9.21964L3.67262 11.1622C3.68524 11.1748 3.69883 11.1858 3.71314 11.1951L4.10908 11.5911ZM15.2959 4.45568L15.7514 3.85991L14.5599 2.94874L14.1043 3.54451L8.29804 11.1373C8.2062 11.2574 8.02961 11.2691 7.92269 11.1623L5.97959 9.21964L5.4492 8.68937L4.38867 9.75017L4.91906 10.2804L6.86216 12.223C7.61058 12.9713 8.84671 12.8892 9.48957 12.0485L15.2959 4.45568Z",
		fill: "currentColor"
	})
});
export default SvgDoubleCheckmarkIcon;
